import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { MunicipioVariacion } from './MunicipioVariacion';
import { Municipio } from '../Municipios/Municipio';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IMunicipioVariacionEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: MunicipioVariacion | undefined;
}

export interface IMunicipioVariacionEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    municipios: Municipio[];
    openErroDialog: boolean;
}

export default class MunicipioVariacionEdit extends React.Component<IMunicipioVariacionEditProps, IMunicipioVariacionEditState> {
    _municipioVariacion: MunicipioVariacion = new MunicipioVariacion();
    _id: number = -1;
    
    public constructor(props: IMunicipioVariacionEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            municipios: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetMunicipios();
    }

    componentWillReceiveProps(nextProps: Readonly<IMunicipioVariacionEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._municipioVariacion = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar municipio
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <Autocomplete
                                renderInput={(params) => (
                                    <TextField {...params} label="Seleccione un municipio" variant="standard" />
                                )}
                                onChange={(event: any, newValue: Municipio | null) => {
                                    this._municipioVariacion.municipio = newValue?.nombre;
                                }}
                                options={this.state.municipios}
                                getOptionLabel={(option: Municipio) => option.nombre!}
                                defaultValue={this.state.municipios.find((value: Municipio) => {
                                    return value.nombre == this._municipioVariacion.municipio;
                                })}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                    <ListItemText>{item.nombre}</ListItemText>
                                    </li>
                                )}
                            />
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' defaultValue={this._municipioVariacion.variacion} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._municipioVariacion.variacion = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._municipioVariacion.variacion == '' || this._municipioVariacion.variacion == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/municipiosvariaciones/${this._municipioVariacion.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._municipioVariacion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._municipioVariacion = new MunicipioVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._municipioVariacion = new MunicipioVariacion();
        });
    }

    private GetMunicipios(): void {
        let url = `${Common.END_POINT}/masters/municipios`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    municipios: response
                }
            );
        })
    }
}